<template>
    <div>
        <BreadCrumb></BreadCrumb>
        <h2>Trackinglist-Vorlage bearbeiten</h2>
        <transition name="fade" mode="out-in">
            <div v-if="loading" :key="0" class="loader">
                <dot-loader id="loader"></dot-loader>
            </div>
            <div v-else :key="1">
                <div v-if="trackingListFetched" class="input-row" style="margin-bottom: 4px">
                    <inputFloatLabel style="width: 100%;margin-right: 4px" label="Vorlagenname"
                                     @input="trackingListNameChanged"
                                     :value="trackingList.name"></inputFloatLabel>
                </div>
                <div v-if="trackingListFetched" class="item-row" style="margin-bottom: 4px">
                    <InputFloatLabel style="width: 200px"
                                     class="setupInfos" icon-size="2.4em" :value="trackingList.target_medium"
                                     label="Mediumbezeichnung"
                                     :icon="this.deviceMapping[trackingList.target_medium]['icon']" iconColor="#D70465"
                                     @click="this.toggleDevice"
                                     @input="deviceInput">
                    </InputFloatLabel>
                    <div class="add-buttons">
                        <AdaButton style="margin-right: 10px" :custom-styles="addModuleStyles"
                                   title="SPACE-VORLAGE LADEN"
                                   @click="openAddSpacesDialog" type="createButton" icon="icon-load"></AdaButton>
                    </div>
                </div>
                <AdaDatatable :columns="columns" :data="[]" :show-pagination="false"
                              :show-search="false"
                              :size-of-page="100">
                </AdaDatatable>
                <!--<template v-if="trackingListFetched">
                    <InteractionRow v-for="inter in trackingList.interactions" v-bind:key="inter.id + inter.name" :name="inter.name"
                                    :technical-name="inter.technical_name" :actions="['delete']"
                                    @onDelete="removeInteraction(inter)"
                                    :description="inter.description">
                    </InteractionRow>
                </template>-->
                <template v-if="trackingListFetched">
                    <div class="space-container" v-for="(space, index) in filteredSpaces" v-bind:key="space.id">
                        <TrackingListSpaceElement @moveUp="moveUp(index)" @moveDown="moveDown(index)"
                                                  @onDelete="deleteSpace(space)" :space="space"
                                                  :technical-name="space.technical_name"
                                                  :interactions="space.filteredInteractions" :widths="columns"
                        ></TrackingListSpaceElement>
                    </div>
                </template>
                <div style="margin-top: 20px">
                    <AdaButton :loading="savingTemplate" style="width: 300px; height: 40px"
                               title="TRACKING-LISTE SPEICHERN" @click="saveClicked"
                               type="createButton"></AdaButton>
                </div>
            </div>
        </transition>
        <Dialog v-if="showAddSpacesDialog" :show-close-button="true" :show="showAddSpacesDialog"
                :has-backdrop="true" width="80%" max-width="1200px"
                @close="closeAddSpacesDialog">
            <SelectSpacesFromTable :initial-spaces="trackingList.spaces" :force-reload="true"
                                   @selected="spacesSelected"></SelectSpacesFromTable>
        </Dialog>
    </div>
</template>

<script>

    import BreadCrumb from "../../../components/breadCrumb/BreadCrumb";
    import AdaDatatable from "../../../components/tables/AdaDatatable";
    import InputFloatLabel from "../../../components/inputs/InputFloatLabel";
    import AdaButton from "../../../components/buttons/AdaButton";
    import Dialog from "../../../components/dialog/Dialog";
    import Transformers from "../../../components/tables/Transformers";
    import SelectSpacesFromTable from "../spaces/SelectSpacesFromTable";
    import TrackingListSpaceElement from "./TrackingListSpaceElement";

    export default {
        components: {
            //SelectInteractionsFromTable,
            TrackingListSpaceElement,
            SelectSpacesFromTable,
            BreadCrumb,
            AdaDatatable,
            InputFloatLabel,
            AdaButton,
            Dialog,
            //InteractionRow
        },
        data: function () {
            return {
                addModuleStyles: {
                    'background-color': '#00b6ed',
                    'border-color': '#00b6ed'
                },
                deviceType: 'Online',
                trackingListFetched: false,
                deviceMapping: {
                    'Online': {
                        'icon': 'icon-device-xdigital'
                    },
                    'Desktop': {
                        'icon': 'icon-device-desktop'
                    },
                    'Mobile': {
                        'icon': 'icon-device-mobile'
                    },
                    'Tablet': {
                        'icon': 'icon-device-tablet'
                    }
                },
                showAddSpacesDialog: false,
                moduleName: '',
                columns: [
                    {
                        viewName: 'Interaction Name',
                        propName: 'name',
                        sortable: true,
                        width: '25%'
                    },
                    {
                        viewName: 'Technischer Name',
                        propName: 'technical_name',
                        width: '25%'
                    },
                    {
                        viewName: 'Aktion',
                        propName: 'action',
                        width: '10%'
                    },
                    {
                        viewName: 'Beschreibung',
                        propName: 'description',
                        width: '40%'
                    }
                ],
                transformers: [
                    {
                        propName: 'target_medium',
                        transform: Transformers.spaceModuleMediumTransformer
                    },
                    {
                        propName: 'action',
                        transform: Transformers.actionTransformer
                    }
                ],
                savingTemplate: false,
                loading: true,
                fn: null
            }
        },
        name: "EditTrackingListTemplate",
        mounted() {
            this.loading = true;
            this.$store.dispatch('trackingListTemplate/fetch', this.$route.params.id).then(() => {
                this.$store.commit('trackingListTemplate/sortSpaces');
                this.trackingListFetched = true;
                this.loading = false;
            });
            this.fn = () => {
                this.saveClicked(true);
            };
            this.$root.$on('saveEditTrackinglist', this.fn);
        },
        beforeDestroy() {
            this.$root.$off('saveEditTrackinglist', this.fn);
        },
        computed: {
            vuexState() {
                return this.$store.state.trackingListTemplate;
            },
            trackingList() {
                return this.$store.getters['trackingListTemplate/trackingList'];
            },
            activeInteractionSpace() {
                return this.vuexState.activeInteractionSpace;
            },
            filteredSpaces() {
                return this.$store.getters['trackingListTemplate/filteredSpaces'];
            },
        },
        watch: {
            deviceType() {
                //this.filterSpacesByType(this.spaces);
                this.$store.commit('trackingListTemplate/filterSpaces', this.deviceType);
            }
        },
        methods: {
            isInteractionValid(inter) {
                let valid = false;
                switch (this.deviceType.toLowerCase()) {
                    case "online":
                        valid = true;
                        break;
                    case "desktop":
                        if (inter.on_desktop === 1) {
                            valid = true;
                        }
                        break;
                    case "mobile":
                        if (inter.on_mobile === 1) {
                            valid = true;
                        }
                        break;
                    case "tablet":
                        if (inter.on_tablet === 1) {
                            valid = true;
                        }
                        break;
                }
                return valid;
            },
            filterSpacesByType(spaces) {
                this.filteredSpaces.length = 0;
                for (let i = 0; i < spaces.length; i++) {
                    let space = spaces[i];
                    this.filteredSpaces.push(space);
                    let filteredInteractions = [];
                    for (let j = 0; j < spaces[i].interactions.length; j++) {
                        let inter = spaces[i].interactions[j];
                        if (this.isInteractionValid(inter)) {
                            filteredInteractions.push(inter);
                        }
                    }
                    for (let j = 0; j < spaces[i].modules.length; j++) {
                        let module = spaces[i].modules[j];
                        let filteredModuleInteractions = [];
                        for (let k = 0; k < module.interactions.length; k++) {
                            let inter = module.interactions[k];
                            if (this.isInteractionValid(inter)) {
                                filteredModuleInteractions.push(inter);
                            }
                        }
                        module.filteredInteractions = filteredModuleInteractions;
                    }
                    space.filteredInteractions = filteredInteractions;
                }
            },
            openAddSpacesDialog() {
                this.showAddSpacesDialog = true;
            },
            moveUp(index) {
                this.$store.commit('trackingListTemplate/moveSpaceUp', index);
            },
            moveDown(index) {
                this.$store.commit('trackingListTemplate/moveSpaceDown', index);
            },
            saveClicked(clickedFromHeader = false) {
                clickedFromHeader ? this.$root.$emit('trackinglistLoader', true) : this.savingTemplate = true;
                this.$store.dispatch('trackingListTemplate/editTrackingList', this.$route.params.id).then(() => {
                    clickedFromHeader ? this.$root.$emit('trackinglistLoader', false) : this.savingTemplate = false;
                });
            },
            deleteSpace(space) {
                this.$store.commit('trackingListTemplate/deleteSpace', space);
            },
            spacesSelected(selectedSpaces) {
                let newSpaces = [];
                for (let i = 0; i < selectedSpaces.length; i++) {
                    let found = false;
                    for (let j = 0; j < this.trackingList.spaces.length; j++) {
                        if (selectedSpaces[i].id === this.trackingList.spaces[j].id) {
                            found = true;
                            break;
                        }
                    }
                    if (!found) {
                        newSpaces.push(selectedSpaces[i]);
                    }
                }
                this.$store.commit('trackingListTemplate/setSpaces', newSpaces);
                this.showAddSpacesDialog = false;
            },
            trackingListNameChanged(val) {
                this.$store.commit('trackingListTemplate/setName', val);
            },
            closeAddSpacesDialog() {
                this.showAddSpacesDialog = false;
            },
            toggleDevice: function () {
                switch (this.deviceType.toLowerCase()) {
                    case 'online':
                        this.deviceType = 'Desktop';
                        break;
                    case 'desktop':
                        this.deviceType = 'Mobile';
                        break;
                    case 'mobile':
                        this.deviceType = 'Tablet';
                        break;
                    case 'tablet':
                        this.deviceType = 'Online';
                        break;
                }
                this.$store.commit('trackingListTemplate/setTargetMedium', this.deviceType);
            },
            deviceInput: function () {
            }
        }
    }
</script>

<style lang="scss" scoped>

    .input-row {
        display: flex;
        flex-direction: row;
        justify-content: space-evenly;
    }

    .item-row {
        display: flex;
        flex-direction: row;
        margin-top: 10px;
        margin-bottom: 10px;
        background-color: white;
        padding: 10px;
        justify-content: space-between;
    }

    .module-container {
        border-bottom: solid 1px $grey;
        border-top: solid 1px $grey;
    }

    .space-container {
        position: relative;
    }

    .add-buttons {
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;

        ::v-deep .createButtons {
            padding: 6px 10px !important;
        }
    }

    .loader {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 200px;
        width: 100%;
    }

    ::v-deep .ada-table-container tr {
        display: flex;
    }

    ::v-deep .ada-table-container td {
        display: block;
    }
</style>